export default __webpack_public_path__ + "static/media/pic3.a6cbb05a.jpg";